import { QueryClient, keepPreviousData } from '@tanstack/react-query';

export const queryClient = new QueryClient();
export { keepPreviousData };